// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sy3dmCqdwHxE8maNXJYq {
	margin-bottom: 32px;
}

.QWu2aQr4FqgOIemkgGFJ {
	background-color: var(--gray);
	display: flex;
	flex-direction: column;
	padding: 20px 32px 32px;
}

.O9LTQzQX5LDoCgiodM3V {
	align-items: center;
	background-color: rgba(255,255,255, 0.5);
	border-radius: 0px 0px 12px 12px;
	color: var(--black);
	display: flex;
	font-size: 16px;
	height: 56px;
	justify-content: space-between;
	letter-spacing: -0.05em;
	line-height: 24px;
	padding: 0 12px;
	margin-bottom: 32px;
}

.jmvd4biNSoT5Wam65gqb {
	border-radius: 12px 12px 0px 0px;
}

.NUCLI9HGkdECGpxQ0QRg {
	margin-bottom: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ConfirmLockPage/ConfirmLockPage.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,wCAAwC;CACxC,gCAAgC;CAChC,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,YAAY;CACZ,8BAA8B;CAC9B,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".banner {\n\tmargin-bottom: 32px;\n}\n\n.content {\n\tbackground-color: var(--gray);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 20px 32px 32px;\n}\n\n.date {\n\talign-items: center;\n\tbackground-color: rgba(255,255,255, 0.5);\n\tborder-radius: 0px 0px 12px 12px;\n\tcolor: var(--black);\n\tdisplay: flex;\n\tfont-size: 16px;\n\theight: 56px;\n\tjustify-content: space-between;\n\tletter-spacing: -0.05em;\n\tline-height: 24px;\n\tpadding: 0 12px;\n\tmargin-bottom: 32px;\n}\n\n.input {\n\tborder-radius: 12px 12px 0px 0px;\n}\n\n.details {\n\tmargin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `sy3dmCqdwHxE8maNXJYq`,
	"content": `QWu2aQr4FqgOIemkgGFJ`,
	"date": `O9LTQzQX5LDoCgiodM3V`,
	"input": `jmvd4biNSoT5Wam65gqb`,
	"details": `NUCLI9HGkdECGpxQ0QRg`
};
export default ___CSS_LOADER_EXPORT___;
